import { STANDARD_NUMBER_HEIGHT, STANDARD_NUMBER_WIDTH } from '@Animation/constants'
import { CYBER_SNAKES_ATLAS_FRAMES, CYBER_SNAKES_TEXTURE_KEYS } from './constants'

export const CyberSnakeTexturePreloader = (scene: Phaser.Scene) => {
  if (!scene.textures.getTextureKeys().includes(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_DEFAULT)) {
    scene.textures.addSpriteSheetFromAtlas(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_DEFAULT, {
      atlas: CYBER_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: CYBER_SNAKES_ATLAS_FRAMES.NUMBER_DEFAULT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED, {
      atlas: CYBER_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: CYBER_SNAKES_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED, {
      atlas: CYBER_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: CYBER_SNAKES_ATLAS_FRAMES.NUMBER_PLAYER_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_HIT)) {
    scene.textures.addSpriteSheetFromAtlas(CYBER_SNAKES_TEXTURE_KEYS.NUMBER_HIT, {
      atlas: CYBER_SNAKES_TEXTURE_KEYS.ATLAS,
      frame: CYBER_SNAKES_ATLAS_FRAMES.NUMBER_HIT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }
}
